import * as filterHeaderTypes from '../../webcommon/header/filterheader/propTypes';
import { lastWorkingDay } from '../../common/helpermethods/HelperMethods';

export const PAGE_REFRESH_RATE = 60000;


export const monitoringStatus = {
    noBreach: 'No IM breach',
    substantial: 'Breach IM substantial level',
    stop: 'Breach IM stop-trading level',
    regulatory: 'Breach IM regulatory level'
};

const availableStatus = Object.values(monitoringStatus).map(
    status => ({
        title: status,
        value: status
    })
);

export const statusOrderingMapping = Object.values(monitoringStatus).reduce(
    (acc, cur, idx) => ({
        ...acc,
        [cur]: idx
    }),
    {}
);

export const filterDefinitions = [
    {
        id: 'runDate',
        title: 'EOD Date',
        type: filterHeaderTypes.filterTypes.date,
        defaultValue: { from: lastWorkingDay(), to: lastWorkingDay(), today: false },
        availableValues: undefined,
        availableValuesLocation: undefined,
        server: true,
        fixed: true,
        useValidation: true,
        hideAllButton: true,
        hideToday: true
    },
    {
        id: 'counterparty',
        title: 'Counterparty',
        type: filterHeaderTypes.filterTypes.list,
        defaultValue: [],
        availableValues: undefined,
        availableValuesLocation: 'api:SystemInfo/counterparties',
        server: true,
        fixed: true,
        customEmptyValue: 'All',
        wide: true,
        includeGroupTitle: false
    },
    {
        id: 'csa',
        title: 'CSA',
        type: filterHeaderTypes.filterTypes.list,
        defaultValue: [],
        availableValues: undefined,
        availableValuesLocation: 'api:SystemInfo/csas',
        server: true,
        fixed: true,
        includeGroupTitle: false
    },
    {
        id: 'status',
        title: 'Monitoring Status',
        type: filterHeaderTypes.filterTypes.list,
        defaultValue: [],
        availableValues: availableStatus,
        availableValuesLocation: null,
        server: false,
        wide: true
    },
    {
        id: 'imThresholdCollectUsd',
        title: 'Threshold Collect USD',
        type: filterHeaderTypes.filterTypes.number,
        defaultValue: { from: null, to: null },
        availableValues: null,
        availableValuesLocation: null,
        server: false
    },
    {
        id: 'imThresholdPostUsd',
        title: 'Threshold Post USD',
        type: filterHeaderTypes.filterTypes.number,
        defaultValue: { from: null, to: null },
        availableValues: null,
        availableValuesLocation: null,
        server: false
    },
    {
        id: 'monitoringThresholdLevel1Usd',
        title: 'Threshold Level 1 USD',
        type: filterHeaderTypes.filterTypes.number,
        defaultValue: { from: null, to: null },
        availableValues: null,
        availableValuesLocation: null,
        server: false
    },
    {
        id: 'monitoringThresholdLevel2Usd',
        title: 'Threshold Level 2 USD',
        type: filterHeaderTypes.filterTypes.number,
        defaultValue: { from: null, to: null },
        availableValues: null,
        availableValuesLocation: null,
        server: false
    },
    {
        id: 'imThresholdEur',
        title: 'IM Threshold EUR',
        type: filterHeaderTypes.filterTypes.number,
        defaultValue: { from: null, to: null },
        availableValues: null,
        availableValuesLocation: null,
        server: false
    },
    {
        id: 'imThresholdCollectEur',
        title: 'Threshold Collect EUR',
        type: filterHeaderTypes.filterTypes.number,
        defaultValue: { from: null, to: null },
        availableValues: null,
        availableValuesLocation: null,
        server: false
    },
    {
        id: 'imThresholdPostEur',
        title: 'Threshold Post EUR',
        type: filterHeaderTypes.filterTypes.number,
        defaultValue: { from: null, to: null },
        availableValues: null,
        availableValuesLocation: null,
        server: false
    },
    {
        id: 'monitoringThresholdLevel1Eur',
        title: 'Threshold Level 1 EUR',
        type: filterHeaderTypes.filterTypes.number,
        defaultValue: { from: null, to: null },
        availableValues: null,
        availableValuesLocation: null,
        server: false
    },
    {
        id: 'monitoringThresholdLevel2Eur',
        title: 'Threshold Level 2 EUR',
        type: filterHeaderTypes.filterTypes.number,
        defaultValue: { from: null, to: null },
        availableValues: null,
        availableValuesLocation: null,
        server: false
    },
    {
        id: 'imPledgeUsd',
        title: 'IM Pledge USD',
        type: filterHeaderTypes.filterTypes.number,
        defaultValue: { from: null, to: null },
        availableValues: null,
        availableValuesLocation: null,
        server: false
    },
    {
        id: 'imPledgeEur',
        title: 'IM Pledge EUR',
        type: filterHeaderTypes.filterTypes.number,
        defaultValue: { from: null, to: null },
        availableValues: null,
        availableValuesLocation: null,
        server: false
    },
    {
        id: 'imReceiveUsd',
        title: 'IM Receive USD',
        type: filterHeaderTypes.filterTypes.number,
        defaultValue: { from: null, to: null },
        availableValues: null,
        availableValuesLocation: null,
        server: false
    },
    {
        id: 'imReceiveEur',
        title: 'IM Receive EUR',
        type: filterHeaderTypes.filterTypes.number,
        defaultValue: { from: null, to: null },
        availableValues: null,
        availableValuesLocation: null,
        server: false
    }
];

export const defaultFilters = [
    {
        definition: filterDefinitions.find(def => def.id === 'runDate'),
        value: {
            from: lastWorkingDay(),
            to: lastWorkingDay(),
            today: false
        }
    },
    {
        definition: filterDefinitions.find(def => def.id === 'counterparty'),
        value: []
    },
    {
        definition: filterDefinitions.find(def => def.id === 'csa'),
        value: []
    }
];
